/* ArtMindr — otvaryane na knigata + parvata stranica (stapka 6).
   Pokazva se SAMO kogato: produktat e kniga za chetene I AMFConfig.innerPage === true
   Rabotи zaedno s am-preview.js (UI) i artmindr-preview-connect.js (API). */
(function(){
  'use strict';
  var root = document.querySelector('[data-amf-root]');
  if(!root) return;
  var book    = root.querySelector('[data-amf-book]');
  var btn     = root.querySelector('[data-amf-openbook]');
  var every   = root.querySelector('[data-amf-everypage]');
  var inner   = root.querySelector('[data-amf-book-inner]');
  var loader  = root.querySelector('[data-amf-inner-loader]');
  var statusEl= root.querySelector('[data-amf-inner-status]');
  var failEl  = root.querySelector('[data-amf-inner-fail]');
  var ring    = root.querySelector('[data-amf-ring]');
  var textEl  = root.querySelector('[data-amf-inner-text]');
  var promise = root.querySelector('[data-amf-promise]');
  var dedm    = root.querySelector('[data-amf-dedm]');
  if(!book || !btn) return;

  function innerEnabled(){
    if(!window.AMFConfig || !window.AMFConfig.innerPage) return false;
    return !!(window.amfState && window.amfState.product === 'reading');
  }

  var R = 52, C = 2 * Math.PI * R;
  if(ring){ ring.style.strokeDasharray = C.toFixed(1); ring.style.strokeDashoffset = C.toFixed(1); }

  var TOTAL = 150000;
  var TIMEOUT = 180000;
  var MAX_PCT = 0.96;

  var opened = false, armed = false, phase = 'idle';
  var t0 = 0, rafId = null, pct = 0, timeoutId = null;

  function childName(){ return (window.amfState && window.amfState.name) || 'детето'; }
  function setRing(p){ pct = p; if(ring){ ring.style.strokeDashoffset = (C * (1 - p)).toFixed(1); } }

  /* posvetenieto se personalizira po pol */
  function fillDedication(){
    var g = (window.amfState && window.amfState.gender) === 'момче' ? 'му' : 'ѝ';
    var line = 'Представи си усмивката ' + g + ', когато се види вътре.';
    Array.prototype.slice.call(root.querySelectorAll('[data-amf-ded-line]')).forEach(function(el){ el.textContent = line; });
  }

  function statusFor(ms){
    var n = childName();
    if(ms < 40000) return 'Рисуваме първата страница на ' + n + '…';
    if(ms < 80000) return 'Слагаме ' + n + ' вътре в историята…';
    return 'Още малко — довършваме детайлите…';
  }

  function tick(){
    var ms = Date.now() - t0;
    var t = Math.min(1, ms / TOTAL);
    setRing(MAX_PCT * (1 - Math.pow(1 - t, 2)));
    if(statusEl){ var s = statusFor(ms); if(statusEl.textContent !== s){ statusEl.textContent = s; } }
    if(phase === 'loading'){ rafId = requestAnimationFrame(tick); }
  }

  function ringToFull(cb){
    if(rafId){ cancelAnimationFrame(rafId); rafId = null; }
    var from = pct, start = Date.now(), dur = 450;
    (function anim(){
      var k = Math.min(1, (Date.now() - start) / dur);
      setRing(from + (1 - from) * k);
      if(k < 1){ requestAnimationFrame(anim); } else if(cb){ cb(); }
    })();
  }

  function showPage(d){
    var img = new Image();
    img.className = 'am-book-innerimg';
    img.alt = 'Първата страница';
    img.onload = function(){
      phase = 'ready';
      ringToFull(function(){
        if(loader) loader.style.display = 'none';
        if(inner) inner.appendChild(img);
        if(every) every.classList.add('is-on');
        if(textEl && d && d.inner_text){ textEl.textContent = d.inner_text; textEl.classList.add('is-on'); }
        btn.textContent = 'Виж как да я получиш ↓';
        btn.setAttribute('data-amf-mode', 'offer');
        btn.disabled = false;
      });
    };
    img.onerror = function(){ failInner(); };
    img.src = d.inner_url;
  }

  function failInner(){
    if(phase === 'ready') return;
    phase = 'failed';
    if(rafId){ cancelAnimationFrame(rafId); rafId = null; }
    if(loader) loader.style.display = 'none';
    if(failEl) failEl.style.display = 'block';
    btn.textContent = 'Опитай отново';
    btn.removeAttribute('data-amf-mode');
    btn.disabled = false;
  }

  function startInner(){
    if(phase === 'loading' || phase === 'ready') return;
    phase = 'loading';
    if(failEl) failEl.style.display = 'none';
    if(loader) loader.style.display = 'flex';
    setRing(0);
    t0 = Date.now();
    if(statusEl) statusEl.textContent = statusFor(0);
    rafId = requestAnimationFrame(tick);
    btn.disabled = true;
    if(timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(function(){ if(phase === 'loading'){ failInner(); } }, TIMEOUT);

    var p;
    if(typeof window.amfGenerateInner === 'function'){ p = window.amfGenerateInner(window.amfState); }
    else { p = Promise.reject(new Error('no connector')); }
    p.then(function(d){
      if(phase !== 'loading') return;
      clearTimeout(timeoutId);
      if(!d || !d.inner_url){ failInner(); return; }
      showPage(d);
    }).catch(function(e){
      console.warn(e && e.message ? e.message : e);
      if(phase !== 'loading') return;
      clearTimeout(timeoutId);
      failInner();
    });
  }

  function openBook(){
    if(!innerEnabled()) return;
    if(!opened){
      opened = true;
      fillDedication();
      book.classList.add('is-open');
      if(dedm) dedm.classList.add('is-on');
      if(typeof window.amfDelaySticky === 'function'){ window.amfDelaySticky(10000); }
    }
    if(phase === 'idle' || phase === 'failed'){ startInner(); }
  }

  btn.addEventListener('click', function(){
    if(btn.getAttribute('data-amf-mode') === 'offer'){
      var o = root.querySelector('[data-amf-offer]');
      if(o) o.scrollIntoView({ behavior:'smooth' });
      return;
    }
    openBook();
  });

  book.addEventListener('click', function(){
    if(!innerEnabled()) return;
    if(!opened){ openBook(); return; }
    book.classList.toggle('is-open');
  });

  function arm(){
    if(armed) return;
    armed = true;
    fillDedication();
    if(promise && window.amfState && window.amfState.product === 'poster'){
      promise.textContent = '✓ Получаваш точно този плакат — това е файлът за печат.';
    }
    if(!innerEnabled()){ btn.style.display = 'none'; return; }
    btn.style.display = '';
    setTimeout(function(){ btn.classList.add('is-ready'); }, 1800);
  }
  var obs = new MutationObserver(function(){
    if(book.querySelector('.am-preview-book-face--front img')){ arm(); obs.disconnect(); }
  });
  obs.observe(book, { childList:true, subtree:true });
  if(book.querySelector('.am-preview-book-face--front img')){ arm(); obs.disconnect(); }
})();